import { Component, Vue } from 'vue-property-decorator';
import DialogBoxComponent from '@/components/dialogBox/dialogBox';
import { Action, Getter, namespace, State } from 'vuex-class';
import { Logger } from 'fsts';
import { ROUTES } from '@/router/routesEnum';
import { msalInstance } from 'vue-msal-browser';
import update from '@/shared/mixins/update';
import LocalStorageUtils from '@/shared/utils/localStorageUtils';
import GeneralUtils from '@/shared/utils/generalUtils';

const logger = new Logger('app');
const authModule = namespace('auth');
const contactModule = namespace('contact');
const companyModule = namespace('company');
const gspUserRoleModule = namespace('gspUserRole');
const gspServiceModule = namespace('gspService');
const gspModuleModule = namespace('gspModule');
const admpNewsModule = namespace('admpNews');

const GSP_MODULE_UPDATE_STORAGE_KEY = 'gsp-module-updated';

@Component({
  components: {},
  mixins: [update],
})
export default class App extends Vue {
  public $refs!: Vue['$refs'] & {
    dialogBox: DialogBoxComponent;
  };
  @State('snackbar')
  private snackbar!: any; //Snackbar
  @Action('hideSnackbar') private releaseSnackbar: any;

  @authModule.Getter('isLoggedIn')
  private isLoggedIn!: boolean;
  @authModule.Getter('getUser')
  private user!: any;
  @authModule.Getter('azureUser')
  private azureUser!: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserSupportOrSuperAdmin!: any;
  @authModule.Action('logout')
  private logoutAction: any;
  @authModule.Action('updateAzureData')
  private updateAzureData: any;
  @authModule.Action('getEnvironment')
  private getEnvironment: any;
  @authModule.Action('canSeeAll')
  private actionCanSeeAll: any;
  @authModule.Action('updateInitialRedirect')
  private updateInitialRedirect: any;
  @authModule.Getter('getEnvironment')
  private getEnvironmentValue: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserInAzureAdminGroup!: any;

  @admpNewsModule.Action('getDashboardAdmpNews')
  private actionGetDashboardAdmpNews!: any;
  @admpNewsModule.Action('getAdmpNewsList')
  private actionGetAdmpNewsList!: any;
  @admpNewsModule.Action('getNewsCountForUser')
  private actionGetNewsCountForUser: any;
  @admpNewsModule.Getter('getUnreadNews')
  private getUnreadNews: any;
  @admpNewsModule.Getter('getAdmpNewsSearchData')
  private getAdmpNewsSearchData!: any;
  @admpNewsModule.Getter('getAdmpNewsSearchParams')
  private admpNewsSearchParams!: any;

  @contactModule.Action('getContactByEmail')
  private getLoggedInContactByEmail: any;
  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: any;
  @contactModule.Action('reloadContact')
  private actionReloadContact: any;

  @companyModule.Action('getUserCompanyZr')
  private actionGetUserCompanyZr: any;

  @gspUserRoleModule.Action('reloadGspUserRolesByContactId')
  private actionReloadGspUserRolesByContactId: any;
  @gspUserRoleModule.Action('reloadGspUserRolesByContactIds') // Add this
  private actionReloadGspUserRolesByContactIds: any;

  @gspModuleModule.Action('fetchAllGspModules')
  private actionFetchAllGspModules!: any;
  @gspServiceModule.Action('updateGspModuleNameInServicesForContacts')
  private actionUpdateGspModuleNameInServicesForContacts!: any;

  get mobile() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  drawer = false;
  toggleMini = true;
  maxHeight = 32;
  maxWidth = 35;

  header = 'title';
  headerTitle = '';
  isNotProductionEnv = false;

  isProductionEnv = GeneralUtils.isProdEnvironment();

  get currentRoute() {
    return this.$route.fullPath;
  }

  get isCorrectRoute(): boolean {
    console.log('this.$route.fullPath :>> ', this.$route.fullPath);
    return (
      !!this.$route.fullPath &&
      !this.$route.fullPath?.includes('task') &&
      !this.$route.fullPath?.includes('spotmarkt') &&
      !this.$route.fullPath?.includes('kollegenauslieferung') &&
      !this.$route.fullPath?.includes('lieferanten') &&
      !this.$route.fullPath?.toLowerCase().includes('mitglieder')
    );
  }

  get isNotProduction() {
    return (
      this.getEnvironmentValue.toLowerCase() === 'localdev' || this.getEnvironmentValue.toLowerCase() === 'staging'
    );
  }

  leftMenuItemsArr: {
    src: string;
    translateId?: string;
    to?: string;
    additionalRoute?: string;
    visible?: boolean;
  }[] = [
    // {
    //   src: 'ico_select',
    //   translateId: 'select',
    //   to: '/',
    //   visible: true,
    // },
    // {
    //   src: 'ico_select',
    //   translateId: 'roles',
    //   to: '/roles',
    // },
    // {
    //   src: 'ico_select',
    //   translateId: 'select',
    //   to: '/vmesupplier',
    // },
  ];

  private isPartialRoute(val: any) {
    if (!val.additionalRoute) {
      return false;
    }
    let route = this.$route.path;
    console.log('appa route :>>  additionalRoute  ', route);
    return route.includes(val.additionalRoute);

    console.log('appa val :>> ', val);
    console.log('appa val.length :>> ', val.length);
    if (val.length > 1) {
      val = val.slice(1);
      let rot = this.$route.path.toString().slice(1);
      console.log('appa rot :>> ', rot);
      let routePartFirst = rot.slice(0, 3);
      console.log('appa routePartFirst :>> ', routePartFirst);
      console.log('appa val.includes(routePartFirst) :>> ', val.includes(routePartFirst));
      return val.includes(routePartFirst) && routePartFirst.length > 2;
    }
    return false; // home `/` route
  }

  get leftMenuItems() {
    // AD-84 from 2024-02-084 allow to see `Roles` only in local and test Area (filtered by domain) (this limitation should be deleted later)
    // Fix bug when no `supplier` and `intern` menu items on load main page (because `isUserSupportOrSuperAdmin` is false on load and only update after Azure login, but menu should be visible on load already for better UX)
    const items: any[] = [];

    items.push({
      src: 'home-outline',
      translateId: 'home',
      to: '/',
      additionalRoute: '/home',
      visible: true,
    });

    items.push({
      src: 'ico_select',
      translateId: 'select',
      to: '/members',
      visible: true,
    });

    if (this.isUserSupportOrSuperAdmin) {
      items.push({
        src: 'ico_select',
        translateId: 'suppliers',
        to: '/suppliers',
        visible: true,
      });
    }

    if (this.isUserSupportOrSuperAdmin) {
      items.push({
        src: 'ico_select',
        translateId: 'intern',
        to: '/intern',
        visible: true,
      });
    }

    if (
      window.location.host.includes('dev4you') ||
      window.location.host.includes('localhost') ||
      this.getEnvironmentValue.toLowerCase() === 'staging'
    ) {
      items.push({
        src: 'ico_select',
        translateId: 'roles',
        to: '/roles',
        additionalRoute: '/role',
        visible: true,
      });
    }

    this.leftMenuItemsArr = items;
    return this.leftMenuItemsArr;
  }

  get isTasksRoute() {
    return (
      this.$route.fullPath.toLowerCase().includes('tasks') ||
      (!!localStorage.getItem('origLocation') && localStorage.getItem('origLocation')?.includes('task'))
    );
  }

  created() {
    logger.log('Hello from github Actions:>> 0.2.11 WITHOUT VOLUMES ');
    logger.log('process.env :>> ', process.env);
    this.getEnvFromBackend();
    LocalStorageUtils.setAzureTokenWithExpireTime();
    this.$msal
      .authenticateRedirect()
      .then((result: any) => {
        // (AD-80) when use `vme-supplier` component in <iframe> tag in Sharepoint portal there is NO Azure data since redirect is NOT allowed (to azure login page)
        logger.log('Azure logging :>> ', result);
        this.updateAzureData(result).then(() => {
          this.actionCanSeeAll().then(() => {
            this.getLoggedInContactByEmail().then((result: any) => {
              this.actionGetNewsCountForUser({
                contactRecordID: this.contactForLoggedInUser?.recordID,
                isUserInAzureAdminGroup: this.isUserSupportOrSuperAdmin,
              });
              console.log('getLoggedInContactByEmail result :>> ', result);
              // public string ZRNummer { get; set; }
              // public bool IsUserInAzureAdminGroup { get; set; }
              console.log('result.primary_Company_Zr_Nummer :>> ', result.primary_Company_Zr_Nummer);
              let payload = {
                zrNummer: result.primary_Company_Zr_Nummer + '',
                isUserInAzureAdminGroup: this.isUserSupportOrSuperAdmin,
              };
              console.log('payload :>> ', payload);
              this.actionGetUserCompanyZr(payload);
            });
          });
        });
        this.handleRedirectAfterAzureLogin();
      })
      .catch((err: any) => {
        logger.error(err);
      });
    setTimeout(() => {}, 3300);
  }

  private handleRedirectAfterAzureLogin() {
    // old logic
    // const currentRoute = this.$router.currentRoute;
    // const redirectPath = currentRoute.query.redirect;
    // if (currentRoute.name == ROUTES.login && redirectPath) {
    //   this.$router.push({ path: redirectPath + '' });
    // } else if (currentRoute.name == ROUTES.login) {
    //   this.$router.push({ name: ROUTES.home });
    // }
    let homeNavLink: any = document.querySelector('[href="/"]');
    homeNavLink.click();

    for (let index = 1; index <= 3; index++) {
      setTimeout(() => {
        this.goToInitialBrowserPath(index);
      }, index * 1300);
    }

    this.startSignalR();
  }

  goToInitialBrowserPath(index: any) {
    console.log('index goToInitialBrowserPath:>> ', index);
    const initialBrowserPath = localStorage.getItem('initialBrowserPath');
    if (initialBrowserPath) {
      // console.log('this.$route.path :>> ', this.$route.path);
      // console.log('this.$route :>> ', this.$route);
      // console.log('this.$router current :>> ', this.$router.currentRoute.path);
      // console.log('initialBrowserPath :>> ', initialBrowserPath);
      // localStorage.removeItem('initialBrowserPath');
      if (this.$router.currentRoute.path == initialBrowserPath || index == 3) {
        localStorage.removeItem('initialBrowserPath');
        this.updateInitialRedirect(false);
      } else {
        // added `catch` to avoid next router error: `NavigationDuplicated`
        this.$router.push({ path: initialBrowserPath }).catch(() => {});
      }
    }
  }

  async initGspModulesWithCache() {
    if (this.$route?.meta?.requiresGsp) {
      await this.actionFetchAllGspModules(); // will use cache when valid
    }
  }

  // !! TODO: (AD-308) test signalR some time if works fine consider this `GSP_MODULE_UPDATE_STORAGE_KEY` logic with `handleGspModuleStorage ` + key
  // Each tab has its own Vuex store; apply rename messages received from another tab locally.
  private handleGspModuleStorage = (event: StorageEvent) => {
    if (event.key !== GSP_MODULE_UPDATE_STORAGE_KEY || !event.newValue) return;

    try {
      const moduleUpdate = JSON.parse(event.newValue);
      const moduleId = Number(moduleUpdate?.id);

      if (!Number.isFinite(moduleId) || moduleId <= 0 || typeof moduleUpdate?.name !== 'string') return;

      this.actionUpdateGspModuleNameInServicesForContacts({
        id: moduleId,
        name: moduleUpdate.name,
      });
    } catch (error) {
      logger.error('Failed to process cross-tab GspModule update:', error);
    }
  };

  mounted() {
    // add cross-tab listener
    window.addEventListener('storage', this.handleGspModuleStorage);
    // placing a global component in app.vue.html and adding ref options (e.g. <myComponent ref="mycomp"></myComponent>)
    // then make a ref global:
    this.$confirm.open = this.$refs.dialogBox.openConfirm;
    this.$message.open = this.$refs.dialogBox.openMessageBox;

    const locale = localStorage.getItem('locale') || this.$i18n.locale; // default locale is `DE` see `i18n.ts`
    this.setLocale(locale);

    this.initGspModulesWithCache();
  }

  beforeDestroy() {
    // Release the cross-tab listener when the root component is destroyed.
    window.removeEventListener('storage', this.handleGspModuleStorage);
    // this.debouncedReloadRoles.cancel();
    this.debounceRegistry.forEach((fn) => fn.cancel());
    this.debounceRegistry.clear();
  }

  private setLocale(locale: string) {
    localStorage.setItem('locale', locale);
    this.$root.$i18n.locale = locale;
    this.$vuetify.lang.current = locale;
  }

  private setHeader(value: string) {
    if (value == 'select') {
      value = 'title';
    }
    this.header = value;
  }

  get hasAzureUser() {
    return this.azureUser?.name;
  }

  async logout() {
    // await this.logoutAction();
    await this.$msal.logoutRedirect();
    this.stopSignalR();

    this.$router.push({ name: ROUTES.login });
  }

  // Create a registry for the debounced functions (different function for different IDs)
  private debounceRegistry: Map<string, ((id: string) => void) & { cancel: () => void }> = new Map();

  private getDebouncedReload(contactId: string) {
    // If we don't have a debouncer for this ID yet, create one
    if (!this.debounceRegistry.has(contactId)) {
      const debouncer = GeneralUtils.debounce((id: string) => {
        logger.debug(`Debounce finished for ID: ${id}`);
        this.actionReloadGspUserRolesByContactId(id);

        // Optional: Cleanup the registry to prevent memory growth
        this.debounceRegistry.delete(id);
      }, 1000);

      this.debounceRegistry.set(contactId, debouncer);
    }

    return this.debounceRegistry.get(contactId)!;
  }

  // // Define the debounced function as a class property (for single ContactId)
  // private debouncedReloadRoles = GeneralUtils.debounce((contactId: string) => {
  //   logger.debug(`📡 Debounce finished: Reloading roles for ${contactId}`);
  //   this.actionReloadGspUserRolesByContactId(contactId);
  // }, 1000); // Wait 1 second after the last SignalR message before fetching

  private startSignalR() {
    this.$backendHub.startSignalR();

    // (AD-277) avoid many `SignalR` calss when quickly click many roles
    this.$backendHub.$on('update:user-roles', (contactId: string) => {
      logger.debug(`update:user-roles event received for contactID: ${contactId}`);

      // 2. Fetch the specific debouncer for this ContactId
      const debouncedFn = this.getDebouncedReload(contactId);
      debouncedFn(contactId);
    });

    this.$backendHub.$on('update:user-roles-multiple', async (contactIds: string[]) => {
      logger.debug('update:user-roles-multiple event received');
      logger.debug(contactIds);
      try {
        const results = await this.actionReloadGspUserRolesByContactIds(contactIds);
        const successes = results.filter((r: any) => r.success);
        const failures = results.filter((r: any) => !r.success);

        if (failures.length > 0) {
          logger.warn(
            `${failures.length} contact User Roles failed to reload from ${contactIds.length} (${successes.length} succeeded)`,
            failures.map((f: any) => f.contactId)
          );
        }
      } catch (error) {
        logger.error('Unexpected error reloading user roles:', error);
      }
    });

    this.$backendHub.$on('update:contact', (contactId: string) => {
      logger.debug('update:contact event received');
      this.actionReloadContact(contactId);
    });

    this.$backendHub.$on('update:admp-news-count', () => {
      logger.debug('---------------------------------update:admp-news-count event received');
      try {
        this.actionGetNewsCountForUser({
          contactRecordID: this.contactForLoggedInUser?.recordID,
          isUserInAzureAdminGroup: this.isUserSupportOrSuperAdmin,
        });
      } catch (error) {
        logger.error('Unexpected error reloading admp-news count:', error);
      }
    });

    this.$backendHub.$on('update:list-admp-news', () => {
      try {
        if (this.currentRoute.includes('/home')) {
          const payload = {
            contactRecordID: this.contactForLoggedInUser?.recordID,
            isUserInAzureAdminGroup: this.isUserInAzureAdminGroup,
          };
          this.actionGetDashboardAdmpNews(payload);
        } else if (this.currentRoute.includes('/newslist')) {
          const payload = {
            searchParams: this.admpNewsSearchParams,
            admpNewsSearchData: this.getAdmpNewsSearchData,
          }; // sent search request from localStorage on reload

          this.actionGetAdmpNewsList(payload);
        }
      } catch (error) {
        logger.error('Unexpected error reloading admp-news:', error);
      }
    });

    this.$backendHub.$on('update:gsp-module-name', (id: number, name: string) => {
      logger.debug(`update:gsp-module-name event received for ID ${id}: ${name}`);
      try {
        this.actionUpdateGspModuleNameInServicesForContacts({ id, name });
      } catch (error) {
        logger.error('Unexpected error updating GspModule name:', error);
      }
    });

    window.addEventListener('beforeunload', () => {
      if (this.isLoggedIn) {
        this.stopSignalR();
      }
    });

    logger.info('signalR started.');
  }

  private stopSignalR() {
    this.$backendHub.$off('update:user-roles');
    this.$backendHub.$off('update:user-roles-multiple');
    this.$backendHub.$off('update:contact');
    this.$backendHub.$off('update:gsp-module-name');

    this.$backendHub.stopSignalR();

    logger.info('signalR stopped');
  }

  getEnvFromBackend() {
    this.getEnvironment().then((result: any) => {
      if (result.toUpperCase() != 'PRODUCTION') {
        this.headerTitle = ' (' + result + ')';
        this.isNotProductionEnv = true;
      }
    });
  }
}
